// extracted by mini-css-extract-plugin
module.exports = {"title":"ThankYouPage_title__1ZPAY","icon":"ThankYouPage_icon__3Y00P","redirectLink":"ThankYouPage_redirectLink__1ameq"};